export default __webpack_public_path__ + "8995e864c6e2995b4cd4481e2931f642.svg";